/**
 * Constructor :
 * - model : global model
 * - options :
 *     	- filtersDisabled : disable filters
 * 		- automaticPlacingDisabled : disable automatic placing
 */
fx.ns("desktop.common.panels", class PhotosPanel extends fx.components.Box {
    
	constructor(model, options)
	{
		super();

		this.model = model;
		this.data = model.photos;
		this.creation = model.creation; //book;

		this.options = options;
		//this.__loading = false;

		this.listenUpdates(this.creation);
		this.listenUpdates(this.model.sharedPhotos);
	}

	
	get data()
	{
		return super.data;
	}

	set data(val)
	{
		if (val instanceof fx.ModelArray)
		{
			super.data = val;

			if (this.grid)
				this.grid.data = val;
		}
		else
		if (val)
		{
			this.model = val;
			this.data = val.photos;
			this.creation = val.creation;

			if (this.filtersButton)
				this.filtersButton.data = val;
			
		}
	}

	get book()
	{
		return this._book;
	}

	set book(val)
	{
		if (this._book)
			this.listenUpdates( this._book, false);

		this._book = val;

		if (this._book)
			this.listenUpdates( this._book, true);

		
	}
	 
	set renderers(val)
	{
		if (this.grid)
			this.grid.renderers = val;
	}

    get photofilters()
    {
        return this.model.photosorts;
    } 


	onReady()
	{
		super.onReady();

		this.on("click", this.addPhoto, this.button);	
		this.on("click", this._hideCreateAlbumToolTip, document);

		if (this.creation)
			this._initFilter()
		
		if (this.magicButton)
		{
			this.on("click", this.onMagic, this.magicButton);
			this.on("mouseover", this._showCreateAlbumToolTip, this.magicButton);
            this._updateMagicButton();
		}

	}

	create()
	{
		super.create();

		// add photo button and filters
		this.boxActions = new fx.components.Box("actions");

		
		if (this.options == undefined || !this.options.automaticPlacingDisabled)
		{
			this.magicButton = new fx.components.IconButton({icon : fx.get("assets").magicIcon, className : "magic"});
            this.boxActions.addChild(this.magicButton, {width : 40, height : 40, left: 290, top : 11});
		}

		if (this.options == undefined || !this.options.filtersDisabled)
		{
			this.filtersButton = new desktop.common.panels.PhotoFilters( this.model);
			this.boxActions.addChild(this.filtersButton, {width : 50, left : this.magicButton ? 250 : 280, top : 11, height:50});
			this.filtersButton.toolTip = fx.text("Trier / filtrer vos photos");
		}

        if (this.options == undefined || !this.options.addPhotoDisabled)
        {
            this.button = new fx.components.Button({label : fx.text("Ajouter des photos"), icon : fx.get("assets").cameraAdd, className : "add"});
            this.boxActions.addChild(this.button, {left: 0, top : 0, width : (!this.magicButton && !this.filtersButton) ? "100%" : (this.magicButton ? 250 : 280)});
        }
    

		if (this.options == undefined || !this.options.addPhotoDisabled || !this.options.filtersDisabled || !this.options.automaticPlacingDisabled)
			this.addChild(this.boxActions, { width : "100%", height : 60, top : 15});

		// photos grid
		this.grid = new fx.components.VerticalGridDynamic( {	data :this.data, 
																renderers : {Photo : shared.renderers.PhotoRenderer}, 
																scrollOnNew : true, 
																hasOnlyUnique : true,
																newChildEffect : "scale",
																maxRowHeight : 150
															 } );

		this.addChild(this.grid, {height:"fill", left : 2, right : 2, top : 90});
	}


	onFilterUserChanged(event)
	{

	}

	addPhoto(e)
	{
		this.data.event("selectphotos", this.model);
	}

	onMagic()
	{
		if (this.data.active.length > 0)
			this.data.event("place-photos-chronologically");
	}

	onChildUpdated(action)
	{
		//if (action.model instanceof models.Photo)
        if (action.model instanceof models.CreationElementContent || action.model instanceof models.Photo)
		{
			//if (action.impacts("number"))
            if (action.impacts("content") || action.impacts("number") || action.impacts("validated"))
				this.delay( this._updateGrid, 250);

			if (this.magicButton)
				this.magicButton.toggleClass("enabled", this.data.active.length > 0);
		}
		
	}

    _updateGrid()
    {
        if (this.grid)
            this.grid.forceUpdate();
    }

    _initFilter()
    {
        if (this.grid && this.creation)
        {
            let filter = this.photofilters.getItemAt( this.creation.photosSort );	
            filter.photosused = this.creation.showphotosused;
            this.grid.filter = filter;
        }
    }
	onDataUpdated(action)
	{
		// if photos are added, let's switch filer to added
		// and let's not do it for 30 secondes (average time of loading large amount of pictures)

		if (action.model instanceof models.ProductBook)
		{
			if (action.type == "init")
				this._initFilter();
		}
		else
		if (action.type == "addItem" && action.data.length === undefined && !this._switchSelectTimer)
			this.delay(this._clearTimerSwitch, 30000);

		if (action.model == this.creation)
		{
			if (action.impacts("photosort"))
                this._initFilter();

			if (action.impacts("showphotosused"))
				this.grid.filter.photosused = this.creation.showphotosused;
		}

		this._updateMagicButton();
			
	}

    _updateMagicButton()
    {
        if (this.magicButton)
        {
            let enabled = this.data.active.length > 0;
            this.magicButton.toolTip = enabled ? fx.text("Placer vos photos automatiquement") : fx.text("Ajoutez des photos puis cliquez ici pour les placer automatiquement");
            this.magicButton.toggleClass("enabled", enabled);
        }
    }

	onDataEvent(e)
    {
		if (e.type == "propose-magic-placement")
			this._showCreateAlbumToolTip();

		if (e.type == "share-upload-validated")
		{
			if(e.detail.photo)
				this.grid.scrollToElement(e.detail.photo);
		}
	}

	_showCreateAlbumToolTip()
	{
		if (!this.magicButton || this.data.active.length < 10)
			return;
			
		if (!this._createAlbumToolTip)
		{
			this._createAlbumToolTip = new desktop.book.edition.CreateAlbumToolTip(this.data);	
			this.addChild(this._createAlbumToolTip, { width : 385, height : 100, top : this.boxActions.y + this.magicButton.y - (100 - this.magicButton.realHeight) / 2, left : this.magicButton.x + this.magicButton.realWidth + 40});
		}
		else
			this._createAlbumToolTip.show();

		this.delay(this._hideCreateAlbumToolTip, 5000);
	}

	_hideCreateAlbumToolTip()
	{
		if (this._createAlbumToolTip)
			this._createAlbumToolTip.hide();
	}

	_clearTimerSwitch()
	{
		this._switchSelectTimer = null;
	}

	selectFilter(index)
	{
		this.filtersButton.selectFilter(index);
	}


	
		
});
